import { isV2Error, V2Error } from '@jetfabric/schemas/lib/protocol-sdk-api-v2/error';

export class JetfabricError extends Error {
  constructor(message?: string) {
    super(message);
    // see: typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html
    // tslint:disable-next-line:no-unsafe-any
    Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain
    this.name = JetfabricError.name; // stack traces display correctly now
  }
}

export class JFSDKError extends JetfabricError implements V2Error {
  public code?: number;
  public realStack?: string;

  constructor(messageOrV2ERROR: V2Error | string) {
    super(isV2Error(messageOrV2ERROR) ? messageOrV2ERROR.message : messageOrV2ERROR);
    if (isV2Error(messageOrV2ERROR)) {
      this.code = messageOrV2ERROR.code;
      this.realStack = messageOrV2ERROR.stack;
    }
    // see: typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html
    // tslint:disable-next-line:no-unsafe-any
    Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain
    this.name = JFSDKError.name; // stack traces display correctly now
  }
}
